<template>
    <!-- 问题预览 -->
    <div class="details">
        <header class="title" v-if="!info.showDialog">
            <span class="pole"></span>
            <span class="str">问题预览</span>
        </header>
        <van-row type="flex" justify="space-between" class="content">
            <div class="preview_content_left">
                <h3 class="content_left_title">{{ info.problemName }}</h3>

                <div class="content_block_box">
                    <p>【问题详情】{{ info.problemLevel }}</p>
                    <div class="content_left_text">
                        <span>{{ getProblemDesc }}</span>
                        <span style="color: #999;" v-if="info.problemDesc.length > 60" @click="expandHideEvent('problemDesc')">{{ visible.problemDesc ? " 收起" : "...展开" }}</span>
                    </div>
                    <div class="content_left_text">
                        问题影响：<span>{{ getProblemAffect }}</span>
                        <span style="color: #999;" v-if="info.problemAffect.length > 60" @click="expandHideEvent('problemAffect')">{{ visible.problemAffect ? " 收起" : "...展开" }}</span>
                    </div>
                    <div class="content_left_text">
                        问题原因：<span v-for="(item, index) in visible.problemCauseList" :key="index">
                            {{ getCauseContent(index) }}
                            <span style="color: #999;" v-if="item.causeContent.length > 60" @click="expandHideListEvent(index,'problemCauseList')">{{ item.visible ? " 收起" : "...展开" }}</span>
                        </span>
                        
                    </div>
                    <div class="content_left_text">
                        制度标准：<span>
                            {{ getProblemAccording }}
                            <span style="color: #999;" v-if="info.problemAccording.length > 60" @click="expandHideEvent('problemAccording')">{{ visible.problemAccording ? " 收起" : "...展开" }}</span>
                        </span>
                    </div>
                </div>
                <div class="content_block_box">
                    <p>【审计建议/意见】</p>
                    <div class="content_left_text color">
                        <span v-for="(item, index) in visible.problemAdviseList" :key="index">
                            {{item.adviseType == 1 ? "建议" : item.adviseType == 2 ? "意见" : "解决方案"}}:{{ getAdviseContent(index) }}
                            <span style="color: #999;" v-if="item.adviseContent.length > 60" @click="expandHideListEvent(index,'problemAdviseList')">{{ item.visible ? " 收起" : "...展开" }}</span>
                        </span>
                    </div>
                </div>
                <div class="content_block_box" v-for="(item, index) in info.problemZgList" :key="index+item.guid">
                    <p>【整改信息】<span v-if="info.problemZgList.length > 1">{{ index + 1 }}</span></p>
                    <div class="content_left_text color">
                        整改措施：<span style="font-family:楷体">
                            {{ getZgContent(index) }}
                            <span style="color: #999;" v-if="item.zgContent.length > 60" @click="expandHideListEvent(index,'problemZgList')">{{ item.visible ? " 收起" : "...展开" }}</span>
                        </span>
                    </div>
                    <div class="content_left_text color">
                        整改责任人：<span style="font-family:楷体">{{ item.zgOrgGuidName }}{{ item.zgPersonName }}</span>
                        ，计划完成时间：<span style="font-family:楷体">{{ item.zgPlanEndTime | timeTransformDate }}</span>
                    </div>
                </div>
            </div>
        </van-row>
    </div>
</template>
<script>
import {timeStampTransformDate} from '@/utils/approve.js'
export default {
    props: {
        info: {
            type: Object,
            require: true
        }
    },
    data() {
        return {
            visible: {
                problemDesc: false,
                problemAffect: false,
                problemCauseList: [],
                problemAccording: false,
                problemAdviseList: [],
                problemZgList: [],
            }
        }
    },
    filters:{
        timeTransformDate(val){
            if(typeof(val) == 'number'){
                return timeStampTransformDate(val);
            } else {
                return val
            }
        }
    },
    methods:{
        expandHideEvent(name){
            this.visible[name] = !this.visible[name];
        },
        expandHideListEvent(index,name){
            let info = this.visible[name].find((item,i) => i == index);
            info.visible = !info.visible;
            this.$set(this.visible[name],index,info);
        },
        getCauseContent(index){
            return this.visible.problemCauseList[index].visible ? this.visible.problemCauseList[index].causeContent : this.visible.problemCauseList[index].causeContent.slice(0,60);
        },
        getAdviseContent(index){
            return this.visible.problemAdviseList[index].visible ? this.visible.problemAdviseList[index].adviseContent : this.visible.problemAdviseList[index].adviseContent.slice(0,60);
        },
        getZgContent(index){
            return this.visible.problemZgList[index].visible ? this.visible.problemZgList[index].zgContent : this.visible.problemZgList[index].zgContent.slice(0,60);
        }
    },
    computed: {
        getProblemDesc(){
            return this.visible.problemDesc ? this.info.problemDesc : this.info.problemDesc.slice(0,60);
        },
        getProblemAffect(){
            return this.visible.problemAffect ? this.info.problemAffect : this.info.problemAffect.slice(0,60);
        },
        getProblemAccording(){
            return this.visible.problemAccording ? this.info.problemAccording : this.info.problemAccording.slice(0,60);
        }
    },
    watch: {
        "info.problemCauseList":{
            deep: true,
            immediate: true,
            handler(newValue,oldValue){
                this.visible.problemCauseList = this.info.problemCauseList.map(item => {
                    return {...item,visible: false}
                })
            }   
        },
        "info.problemAdviseList":{
            deep: true,
            immediate: true,
            handler(newValue,oldValue){
                this.visible.problemAdviseList = this.info.problemAdviseList.map(item => {
                    return {...item,visible: false}
                })
            }   
        },
        "info.problemZgList":{
            deep: true,
            immediate: true,
            handler(newValue,oldValue){
                this.visible.problemZgList = this.info.problemZgList.map(item => {
                    return {...item,visible: false}
                })
            }   
        },
    }
}
</script>
<style lang="less" scoped>
    //主标题字号
    @titleSize: 16px;
    //主标题颜色
    @titleColor: #0ea6e0;
    //中等字号
    @middleSize: 14px;
    //主体小字字号
    @contentSize: 12px;
    //内容小字颜色
    @contentColor: #7f7f7f;

    //板块radius
    @borderRadius: 4px;

    //边框阴影
    @boxShadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.2);

    //预览标题颜色
    @previewColor: #000;
    .details{
            background-color: #fff;
            border-radius: @borderRadius;
            box-shadow: @boxShadow;
            overflow: hidden;
            margin-top: 15px;
            padding-bottom: 10px;
            text-align: left;
            font-size: @contentSize;
            .title{
                margin: 20px 15px 0 15px;
                text-align: left;
                overflow: hidden;
                position: relative;
                .pole{
                    color: @titleColor;
                    font-size: @titleSize;
                    border-left: 3px solid #0ea6e0;
                }
                .str{
                    width: 100%;
                    font-size: @middleSize;
                    display: inline-block;
                    margin-left: 5px;
                    font-weight: bold;
                    padding-bottom: 5px;
                    border-bottom: 1px solid #d7d7d7;
                }
            }
            .content{
                margin: 10px 15px 5px 23px;
                padding-bottom: 3px;
                border-bottom: 1px solid #f3f3f3;

                .preview_content_left{
                    text-align: center;
                    box-sizing: border-box;
                    width: 100%;
                    .content_left_title{
                        font-size: @middleSize;
                        font-weight: 700;
                        color: @previewColor;
                        margin: 30px 0;
                    }
                    .content_block_box{
                        font-size: @contentSize;
                        color: @contentColor;
                        margin-top: 20px;
                        p{
                            color: @previewColor;
                            text-align: left;
                            font-weight: bold;
                            font-size: 13px;
                        }
                        .content_left_text{
                            background-color: #f0f4ff;
                            padding: 10px;
                            width: 100%;
                            display: inline-block;
                            box-sizing: border-box;
                            border-radius: 4px;
                            margin-top: 5px;
                            color:#333;
                            text-align:justify;
                            text-indent: 13px;
                            line-height: 20px;
                            span{
                                font-family: 楷体;
                            }
                        }
                        .color{
                            color: @titleColor;
                        }
                        .overstep{
                            overflow:hidden;
                            display:-webkit-box;
                            -webkit-line-clamp:3;
                            -webkit-box-orient:vertical;
                            text-overflow:ellipsis;
                            white-space:pre-wrap;
                            word-wrap:break-word;
                        }
                    }
                }
                
            }
            .content:last-child{
                border: unset;
            }
        }
</style>